import { render, staticRenderFns } from "./FixedAlert.vue?vue&type=template&id=2f65374d&scoped=true&"
import script from "./FixedAlert.vue?vue&type=script&lang=js&"
export * from "./FixedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65374d",
  null
  
)

export default component.exports